<script>
    import Button, { Icon } from '@smui/button';
    import Card from '@smui/card';
    import DataTable, { Body, Cell, Row } from '@smui/data-table';
    import { onMount } from 'svelte';
    import ContactFooter from "../common/contact/ContactFooter.svelte";
    import ErrorDialog from "../common/error/ErrorDialog.svelte";
    import { changePage } from "../common/navigation";
    import BoldCell from '../common/table/BoldCell.svelte';
    import { organizationStore } from "../organizations/organizations";
    import { subscriptionTermLabel } from "../users/userConstants";
    import { getUsersForOrganization, organizationWithoutAdminEh3 } from "./summary";
    let errorDialog;

    function displayUserAdmin(user) {
        return user.admin ? "Ja" : ""
    }

    function getUsersByOrganization(organization) {
        return getUsersForOrganization(organization).sort(function (a, b) {
            if (a.admin === b.admin)
                return 0
            else if (a.admin)
                return -1
            else
                return 1
        })
    }

    onMount(() => {
        if ($organizationWithoutAdminEh3.length > 0) {
            errorDialog.open(`De volgende bedrijven hebben op dit moment nog geen beheerder op niveau 3: ${$organizationWithoutAdminEh3.map(organization => organization.name).join()} \nPer bedrijf dient er tenminste één beheerder te worden aangesteld`, "Terug")
        }
    });

</script>
<div class="container-fluid mb-3">
    <div class="row justify-content-center">
        <div class="col-12">
            <Card>
                <div class="cng-card__primary cng-card__header-with-buttons">
                    <div class="mdc-typography--headline5">Overzicht</div>
                    <div>
                        <Button on:click={() => changePage('/#/organizations')} variant="raised" class="button-shaped-round"><Icon class="material-icons">add</Icon><Icon class="material-icons">business</Icon></Button>
                        <Button on:click={() => changePage('/#/users')}  variant="raised" class="button-shaped-round"><Icon class="material-icons">add</Icon><Icon class="material-icons">account_circle</Icon></Button>
                    </div>
                </div>
                <div class="cng-card__divider"></div>
                <ErrorDialog  bind:this={errorDialog} on:action={() => changePage('/#/users')}/>
                <div>
                    {#each $organizationStore as organization}
                        <div class="table-title upper-case">
                            #{organization.companyId} {organization.name}
                        </div>
                        <DataTable table$aria-label="{organization.name}" style="width: 100%">
                            <Body>
                                <Row style="background-color: lightgray">
                                    <BoldCell>NAAM</BoldCell>
                                    <BoldCell>KVK NUMMER</BoldCell>
                                    <BoldCell>VESTINGSNR.</BoldCell>
                                    <BoldCell>STRAAT</BoldCell>
                                    <BoldCell>HUISNUMMER</BoldCell>
                                    <BoldCell>POSTCODE</BoldCell>
                                    <BoldCell>STAD</BoldCell>
                                    <BoldCell>LAND</BoldCell>
                                </Row>
                                <Row>
                                    <Cell>{organization.name}</Cell>
                                    <Cell>{organization.kvk}</Cell>
                                    <Cell>{organization.branch}</Cell>
                                    <Cell>{organization.street}</Cell>
                                    <Cell>{organization.number}</Cell>
                                    <Cell>{organization.postCode}</Cell>
                                    <Cell>{organization.city}</Cell>
                                    <Cell>{organization.country}</Cell>
                                </Row>
                                <Row style="background-color: lightgray">
                                    <BoldCell>NAAM</BoldCell>
                                    <BoldCell>EH LEVEL</BoldCell>
                                    <BoldCell>ABONNEMENT</BoldCell>
                                    <BoldCell>AUTHENTICATIE</BoldCell>
                                    <BoldCell>EMAIL</BoldCell>
                                    <BoldCell>TELEFOONNUMMER</BoldCell>
                                    <BoldCell>GEBOORTEDATUM</BoldCell>
                                    <BoldCell>BEHEERDER</BoldCell>
                                </Row>
                                {#each getUsersByOrganization(organization) as user}
                                    <Row>
                                        <Cell>{user.initial} {user.lastName}</Cell>
                                        <Cell>{user.ehLevel}</Cell>
                                        <Cell>{subscriptionTermLabel(user.subscriptionTerm)}</Cell>
                                        <Cell>{user.secondFactor}</Cell>
                                        <Cell>{user.email}</Cell>
                                        <Cell>{user.phoneNumber}</Cell>
                                        <Cell>{user.birthDate}</Cell>
                                        <Cell>{displayUserAdmin(user)}</Cell>
                                    </Row>
                                {/each}
                            </Body>
                        </DataTable>
                    {/each}
                </div>
                <ContactFooter/>
            </Card>
        </div>
    </div>
</div>
<style>
    .table-title {
        font-weight: bold;
        background-color: #03DAC5;
        padding: 15px;
    }
    .upper-case {
        text-transform: uppercase;
    }
</style>
